export function TripleCoinsIcon() {
  return (
    <svg
      className="size-[46px]"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background circle */}
      <g transform="translate(4.532, 4.532)">
        <path
          d="M18.6492 37.2983C8.35667 37.2983 0 28.9321 0 18.6492C0 8.36625 8.35667 0 18.6492 0C28.9417 0 37.2983 8.36625 37.2983 18.6492C37.2983 28.9321 28.9321 37.2983 18.6492 37.2983Z"
          fill="url(#paint0_linear_triple_coins)"
        />
      </g>

      {/* 3x coin group */}
      <g transform="translate(9.271, 9.271)">
        <path
          d="M29.2483 16.7229C29.2579 16.79 29.2579 16.8667 29.2579 16.9338C29.2579 23.7475 22.7125 29.2675 14.6242 29.2675C6.53583 29.2675 4.76837e-07 23.7475 4.76837e-07 16.9338C4.76837e-07 16.8667 6.96396e-07 16.79 0.00958403 16.7229H4.76837e-07V12.1708H29.2483V16.7229Z"
          fill="url(#paint1_linear_triple_coins)"
        />
        <path
          d="M14.6338 24.6675C22.7125 24.6675 29.2579 19.1475 29.2579 12.3338C29.2579 5.52 22.7125 4.76837e-07 14.6338 4.76837e-07C6.555 4.76837e-07 0.00958403 5.52 0.00958403 12.3338C0.00958403 19.1475 6.555 24.6675 14.6338 24.6675Z"
          fill="url(#paint2_linear_triple_coins)"
        />
        <path
          d="M14.6338 21.4762C20.6138 21.4762 25.4725 17.3842 25.4725 12.3433C25.4725 7.3025 20.6233 3.21042 14.6338 3.21042C8.64417 3.21042 3.795 7.3025 3.795 12.3433C3.795 17.3842 8.64417 21.4762 14.6338 21.4762Z"
          fill="url(#paint3_linear_triple_coins)"
        />
        <g>
          <path
            opacity="0.8"
            d="M10.3117 17.0296C9.12333 17.0296 8.1075 16.7421 7.39834 16.1958C6.80417 15.7454 6.50708 15.18 6.50708 14.5379C6.50708 13.5413 7.245 12.7842 8.23208 12.7363C7.97333 12.4296 7.82 12.0367 7.82 11.6054C7.82 11.1742 7.96375 10.8004 8.2225 10.4938C7.43667 10.3117 6.86167 9.6025 6.86167 8.73042C6.86167 8.18417 7.13 7.66667 7.60917 7.27375C8.27042 6.7275 9.33417 6.3825 10.3979 6.3825C12.5829 6.3825 14.1163 7.705 14.1163 9.59292C14.1163 10.2542 13.9246 10.8771 13.57 11.385C14.0971 11.9408 14.3846 12.6692 14.3846 13.5029C14.3846 15.5442 12.6788 17.02 10.3213 17.02L10.3117 17.0296Z"
            fill="url(#paint4_linear_triple_coins)"
          />
          <path
            d="M12.0558 11.5C12.8896 11.8642 13.4263 12.5446 13.4263 13.5125C13.4263 15.0171 12.1517 16.0808 10.3117 16.0808C9.26708 16.0808 8.48125 15.8317 7.97333 15.4483C7.6475 15.1992 7.46542 14.9213 7.46542 14.5475C7.46542 14.0492 7.81042 13.7042 8.3375 13.7042C8.59625 13.7042 8.86458 13.8192 9.11375 14.0013C9.43958 14.2217 9.82292 14.3463 10.3308 14.3463C10.9921 14.3463 11.4808 13.9246 11.4808 13.3783C11.4808 12.8321 11.0688 12.42 10.1775 12.42H9.64083C9.17125 12.42 8.77833 12.0942 8.77833 11.6246C8.77833 11.155 9.16167 10.8292 9.64083 10.8292H10.1488C10.81 10.8292 11.27 10.4842 11.27 9.96667C11.27 9.44917 10.8196 9.085 10.2254 9.085C9.81333 9.085 9.50667 9.24792 9.21917 9.42042C9.01792 9.545 8.84542 9.6025 8.63458 9.6025C8.17458 9.6025 7.82958 9.23833 7.82958 8.74C7.82958 8.49083 7.95417 8.24167 8.23208 8.02125C8.66333 7.65708 9.50667 7.35042 10.4075 7.35042C11.96 7.35042 13.1675 8.15542 13.1675 9.6025C13.1675 10.3404 12.8321 11.0879 12.075 11.4904L12.0558 11.5Z"
            fill="white"
          />
          <path
            opacity="0.8"
            d="M20.8054 17.0296C20.2592 17.0296 19.7225 16.7804 19.3392 16.3396L18.8312 15.7454L18.3329 16.3492C17.9783 16.79 17.4608 17.0296 16.8763 17.0296C15.8508 17.0296 14.9788 16.1575 14.9788 15.1321C14.9788 14.6529 15.1608 14.2121 15.525 13.8L16.2917 12.9567L15.5825 12.1708C15.2375 11.8067 15.0458 11.3275 15.0458 10.8292C15.0458 9.76542 15.8988 8.90292 16.9529 8.90292C17.5471 8.90292 18.0646 9.1425 18.4192 9.57375L18.9079 10.1583L19.4063 9.57375C19.7513 9.1425 20.2688 8.90292 20.8533 8.90292C21.8788 8.90292 22.7508 9.775 22.7508 10.8004C22.7508 11.2796 22.5688 11.7204 22.2046 12.1325L21.4379 12.9663L22.1567 13.7138C22.5304 14.1067 22.7317 14.5954 22.7317 15.0842C22.7317 16.1383 21.85 17.02 20.8054 17.02V17.0296Z"
            fill="url(#paint5_linear_triple_coins)"
          />
          <path
            d="M20.1058 15.6783L18.8217 14.1738L17.5567 15.7071C17.3842 15.9179 17.1638 16.0233 16.8858 16.0233C16.4067 16.0233 16.0042 15.6113 16.0042 15.1417C16.0042 14.9213 16.1 14.7104 16.2917 14.4804L17.6621 12.9663L16.3396 11.5C16.1383 11.2892 16.0617 11.0496 16.0617 10.8388C16.0617 10.3404 16.4738 9.92833 16.9625 9.92833C17.2117 9.92833 17.4608 10.005 17.6525 10.235L18.9079 11.7492L20.1921 10.2446C20.3646 10.0338 20.585 9.92833 20.8629 9.92833C21.3421 9.92833 21.7446 10.3404 21.7446 10.81C21.7446 11.0304 21.6488 11.2413 21.4571 11.4713L20.0579 12.9854L21.4283 14.4229C21.6296 14.6338 21.7158 14.8733 21.7158 15.0938C21.7158 15.5825 21.3038 16.0138 20.8054 16.0138C20.5371 16.0138 20.2879 15.8796 20.1058 15.6688V15.6783Z"
            fill="white"
          />
        </g>
      </g>

      <defs>
        <linearGradient
          id="paint0_linear_triple_coins"
          x1="13.3792"
          y1="40.6908"
          x2="26.3167"
          y2="0.440795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E300" />
          <stop offset="0.5" stopColor="#00FC00" />
          <stop offset="0.653886" stopColor="#17FC00" />
          <stop offset="1" stopColor="#8CFC00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_triple_coins"
          x1="14.6333"
          y1="29.9664"
          x2="14.6333"
          y2="8.40395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09451E" />
          <stop offset="1" stopColor="#00A000" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_triple_coins"
          x1="14.6335"
          y1="0.258301"
          x2="14.6335"
          y2="25.175"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C800" />
          <stop offset="1" stopColor="#007900" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_triple_coins"
          x1="15.5907"
          y1="21.342"
          x2="15.5907"
          y2="3.13368"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#075818" />
          <stop offset="1" stopColor="#009D0F" stopOpacity="0.6" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_triple_coins"
          x1="12.8417"
          y1="4.45625"
          x2="8.72083"
          y2="17.0775"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BAF970" stopOpacity="0.5" />
          <stop offset="1" stopColor="#7BF744" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_triple_coins"
          x1="20.815"
          y1="7.04375"
          x2="16.6942"
          y2="19.665"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BAF970" stopOpacity="0.5" />
          <stop offset="1" stopColor="#7BF744" stopOpacity="0.2" />
        </linearGradient>
      </defs>
    </svg>
  )
}
